"use client";

import { c as _c } from "react/compiler-runtime";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { RELAY_SOLANA_MAINNET_CHAIN_ID } from "../../../../anyspend/index.js";
import { ShinyButton, useAccountWallet, useProfile } from "../../../../global-account/react/index.js";
import centerTruncate from "../../../../shared/utils/centerTruncate.js";
import { formatTokenAmount } from "../../../../shared/utils/number.js";
import { motion } from "framer-motion";
import { ChevronRight, Loader2 } from "lucide-react";
import { useAnySpendCustomization } from "../context/AnySpendCustomizationContext.js";
import { CryptoPaymentMethodType } from "./CryptoPaymentMethod.js";
import { OrderDetailsCollapsible } from "./OrderDetailsCollapsible.js";
import { PaymentMethodSwitch } from "./PaymentMethodSwitch.js";
export default function ConnectWalletPayment(t0) {
  const $ = _c(9);
  const {
    order,
    onPayment,
    txLoading,
    isSwitchingOrExecuting,
    phantomWalletAddress,
    tournament,
    nft,
    cryptoPaymentMethod,
    onPaymentMethodChange
  } = t0;
  let t1;
  if ($[0] !== order.recipientAddress) {
    t1 = {
      address: order.recipientAddress
    };
    $[0] = order.recipientAddress;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const profile = useProfile(t1);
  const recipientName = profile.data?.name?.replace(/\.b3\.fun/g, "");
  const {
    connectedEOAWallet,
    connectedSmartWallet
  } = useAccountWallet();
  const connectedEvmAddress = cryptoPaymentMethod === CryptoPaymentMethodType.GLOBAL_WALLET ? connectedSmartWallet?.getAccount()?.address : connectedEOAWallet?.getAccount()?.address;
  const {
    slots
  } = useAnySpendCustomization();
  const srcToken = order.metadata.srcToken;
  const dstToken = order.metadata.dstToken;
  const expectedDstAmount = order.type === "mint_nft" || order.type === "join_tournament" || order.type === "fund_tournament" || order.type === "custom" ? "0" : order.payload.expectedDstAmount.toString();
  const formattedExpectedDstAmount = formatTokenAmount(BigInt(expectedDstAmount), dstToken.decimals);
  if (!srcToken || !dstToken) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = _jsx("div", {
        children: "Loading..."
      });
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  const paymentLabel = order.srcChain === RELAY_SOLANA_MAINNET_CHAIN_ID && phantomWalletAddress ? "Pay from Phantom Wallet" : cryptoPaymentMethod === CryptoPaymentMethodType.GLOBAL_WALLET ? "Pay from Global Account" : "Pay from Connected Wallet";
  const connectedAddress = order.srcChain === RELAY_SOLANA_MAINNET_CHAIN_ID && phantomWalletAddress ? phantomWalletAddress : connectedEvmAddress;
  if (slots.connectWalletButton) {
    let t2;
    if ($[3] !== connectedAddress || $[4] !== onPayment || $[5] !== paymentLabel || $[6] !== slots || $[7] !== txLoading) {
      t2 = _jsx("div", {
        className: "flex w-full flex-col items-center gap-6",
        children: slots.connectWalletButton({
          onPayment,
          txLoading,
          connectedAddress: connectedAddress || undefined,
          paymentLabel
        })
      });
      $[3] = connectedAddress;
      $[4] = onPayment;
      $[5] = paymentLabel;
      $[6] = slots;
      $[7] = txLoading;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    return t2;
  }
  return _jsx("div", {
    className: "flex w-full flex-col items-center gap-6",
    children: _jsxs(motion.div, {
      initial: {
        opacity: 0,
        y: 20
      },
      animate: {
        opacity: 1,
        y: 0
      },
      transition: {
        delay: 0.5
      },
      className: "flex w-full flex-col items-center gap-2",
      children: [_jsx(ShinyButton, {
        accentColor: "hsl(var(--as-brand))",
        textColor: "text-white",
        className: "flex w-5/6 max-w-[400px] items-center gap-2 sm:px-0",
        disabled: txLoading || isSwitchingOrExecuting,
        onClick: onPayment,
        children: txLoading ? _jsxs(_Fragment, {
          children: ["Transaction Pending", _jsx(Loader2, {
            className: "ml-2 h-5 w-5 animate-spin"
          })]
        }) : _jsxs(_Fragment, {
          children: [_jsx("span", {
            className: "whitespace-nowrap pl-4 text-lg md:text-sm",
            children: paymentLabel
          }), _jsx(ChevronRight, {
            className: "h-4 w-4"
          })]
        })
      }), _jsxs("span", {
        className: "label-style text-as-primary/50 text-xs",
        children: ["Connected to:", " ", order.srcChain === RELAY_SOLANA_MAINNET_CHAIN_ID && phantomWalletAddress ? centerTruncate(phantomWalletAddress, 6) : centerTruncate(connectedEvmAddress || "")]
      }), _jsx(PaymentMethodSwitch, {
        currentMethod: cryptoPaymentMethod,
        onMethodChange: onPaymentMethodChange
      }), _jsx("div", {
        className: "mt-4",
        children: _jsx(OrderDetailsCollapsible, {
          order,
          dstToken,
          tournament,
          nft,
          recipientName,
          formattedExpectedDstAmount
        })
      })]
    })
  });
}